import { Card, message, PageHeader, Table } from 'antd';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import React, { useEffect, useState } from 'react'
import { fetchCaseStudyList } from '../../services/apis';

export const CaseStudy = () => {
    const [loading, setLoading] = useState(false)
    const [caseStudy, setCaseStudy] = useState([])

    const caseStudyColumns = [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Download Counts',
            dataIndex: 'case_study_download_count',
            key: 'case_study_download_count',
            render: (text) => <Text>{text || "-"}</Text>
        },
        {
            title: 'Created On',
            dataIndex: 'created',
            key: 'created',
            render: (createdOn) => <Text>{new Date(createdOn).toLocaleString([], { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }) || "-"}</Text>
        },
    ]

    useEffect(() => {
        setLoading(true)
        fetchCaseStudyList().then((res) => {
            if (res.status === 200) {
                setLoading(false)
                setCaseStudy(res.data.result.data)
            } else {
                message.error('Not able to Case Studies')
            }
        }).catch((err) => {
            console.log('ERROR IN Case Studies', err);
        })
    }, [])
    return (
        <div>
            <PageHeader style={{ margin: "0 0 1.5rem 0", padding: 0 }}>
                <Card>
                    <Title level={5}>Case Study Download</Title>
                </Card>
            </PageHeader>
            <Table dataSource={caseStudy} columns={caseStudyColumns} loading={loading} bordered />
        </div>
    )
}
